import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldVariableLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldVariableLabel';

defineBlock({
    type: 'var_increment_number',
    colour: CATEGORIES.variable.color,
    tooltip: '数値変数を指定した値だけ増やす・減らす',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/var_number.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () =>
                        new FieldStyledLabel('変数セット', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('数値'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'field',
                    name: 'VAR_LABEL',
                    instance: () => new FieldVariableLabel('設定する変数', { fontWeight: 'normal', varType: 'float' }),
                },
                { type: 'label', text: 'を' },
            ],
        },
        {
            kind: 'value',
            name: 'AMOUNT',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 1 } },
        },
        {
            kind: 'dummy',
            fields: [
                { type: 'label', text: 'だけ' },
                {
                    type: 'field',
                    name: 'OP',
                    instance: () =>
                        new FieldOperatorDropdown([
                            { value: 'increment', label: '増やす' },
                            { value: 'decrement', label: '減らす' },
                        ]),
                },
            ],
        },
    ],
});
